import React, { useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom';

const UniversalSearchBar = () => {
    const [query, setQuery] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const inputRef = useRef();
    const navigate = useNavigate();

    const searchItems = [
        { id: 1, title: "Dashboard", path: "/" },
        { id: 2, title: "Controller", path: "/controller" },
        { id: 3, title: "Profile", path: "/profile" },
        { id: 4, title: "Notification", path: "/notification" },
        { id: 5, title: "Logout", path: "/Logout" },
        { id: 6, title: "User", path: "/manage/user/all/data" },
        { id: 7, title: "Login", path: "/manage/user/login/all/data" },
        { id: 8, title: "Withdraw Request", path: "/manage/withdraw/request" },
        { id: 9, title: "Withdraw Coupon Generate", path: "/manage/withdraw/coupon" },
        { id: 10, title: "Leaderboard", path: "/main/leaderboards" },
        { id: 11, title: "Daily Streak Earn", path: "/manage/quiz/daily/streak/earn" },
        { id: 12, title: "Read and Earn", path: "/manage/quiz/read/earn" },
        { id: 13, title: "Tap to Earn", path: "/manage/quiz/tap/earn" },
        { id: 14, title: "Whois Earn", path: "/manage/quiz/whois/earn" },
        { id: 15, title: "Ad Earn", path: "/manage/quiz/ad/earn" },
        { id: 16, title: "Native Ads", path: "/manage/ads/nativeAds/add" },
        { id: 17, title: "Fullscreen Ads", path: "/manage/ads/fullScreenAds/add" },
        { id: 18, title: "Banner Ads", path: "/manage/ads/bannerAds/add" },
        { id: 19, title: "Open Ads", path: "/manage/ads/openAds/add" },
        { id: 20, title: "Reward Ads", path: "/manage/ads/rewardAds/add" },
        { id: 21, title: "InHouse Ads", path: "/manage/ads/inHouseAds/add" },
        { id: 22, title: "Guide Video", path: "/guide/video" },
        { id: 23, title: "Rules", path: "/rules" },
        { id: 24, title: "Terms & Conditions", path: "/policy/terms" },
        { id: 25, title: "Privacy Policy", path: "/policy" },
        { id: 26, title: "Contact Us", path: "/policy/contactus" },
        { id: 26, title: "Chat", path: "/manage/contact/chat" },
    ];

    const handleSearch = (e) => {
        const value = e.target.value;
        setQuery(value);
        if (!value) return setSuggestions([]);

        const filtered = searchItems.filter(item =>
            item.title.toLowerCase().includes(value.toLowerCase())
        );
        setSuggestions(filtered.slice(0, 5));
    };

    const handleSelect = (path) => {
        navigate(path);
        setQuery('');
        setSuggestions([]);
    };

    return (
        <div className="relative mx-4 w-full max-w-xs hidden md:block">
            <input
                ref={inputRef}
                type="text"
                value={query}
                onChange={handleSearch}
                placeholder="Search..."
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            {query && suggestions.length > 0 && (
                <ul className="absolute top-full left-0 right-0 bg-white shadow-lg border rounded-md mt-1 z-50">
                    {suggestions.map((item) => (
                        <li
                            key={item.id}
                            className="px-3 py-2 cursor-pointer hover:bg-gray-100"
                            onClick={() => handleSelect(item.path)}
                        >
                            {item.title}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}

export default UniversalSearchBar